import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { websocketActionsWorkspaces } from '@/common/context/websocketActions/constants'
import useWebsocketActions from '@/common/hooks/useWebsocketActions/useWebsocketActions'
import { actionsReasons } from '@/returns/pages/TransactionDetailPage/constants'
import returnsServices from '@/returns/services/services'

import { pendingWebsocketActionTypes } from '../useWebsocketTransactionAction/constants'
import { getPayload } from './helpers'

const useSchedulePickup = ({ orderId, setToastInfo, allowsSchedulePickupReason }) => {
  const [showSchedulePickupDrawer, setShowSchedulePickupDrawer] = useState(false)
  const [selectedPickupDate, setSelectedPickupDate] = useState('')
  const [selectedTimeRange, setSelectedTimeRange] = useState('')
  const { setPendingWebsocketAction } = useWebsocketActions(websocketActionsWorkspaces.transactions)
  const { fetchData: schedulePickup, loading: schedulingPickup } = useFetch(returnsServices.schedulePickup, {
    doInitialRequest: false,
  })
  const {
    data: datesAndTimeRangesForSchedulePickup,
    loading: fetchingDatesAndTimeRangesForSchedulePickup,
    fetchData: getDatesAndTimeRangesForSchedulePickup,
  } = useFetch(returnsServices.getDatesAndTimeRangesForSchedulePickup, { doInitialRequest: false })

  const openSchedulePickupDrawer = async () => {
    setShowSchedulePickupDrawer(true)

    const data = await getDatesAndTimeRangesForSchedulePickup({ orderId })

    setSelectedPickupDate(data?.pickup_dates?.[0] || '')
    setSelectedTimeRange(data?.time_ranges?.[0]?.id || '')
  }

  const closeSchedulePickupDrawer = () => {
    setShowSchedulePickupDrawer(false)
  }

  const onSchedulePickup = async () => {
    try {
      const response = await schedulePickup({
        orderId,
        payload: getPayload({
          pickupDates: datesAndTimeRangesForSchedulePickup?.pickup_dates,
          timeRanges: datesAndTimeRangesForSchedulePickup?.time_ranges,
          selectedPickupDate,
          selectedTimeRange,
        }),
      })

      setShowSchedulePickupDrawer(false)
      setPendingWebsocketAction(pendingWebsocketActionTypes.schedulePickup, response)
    } catch (err) {
      setToastInfo({ show: true, message: err.errorMessage, type: 'error' })
    }
  }

  const isSchedulePickupDisabled = [actionsReasons.pickupScheduled, actionsReasons.maxReturnLabels].includes(
    allowsSchedulePickupReason
  )

  return {
    showSchedulePickupDrawer,
    setShowSchedulePickupDrawer,
    schedulingPickup,
    onSchedulePickup,
    openSchedulePickupDrawer,
    closeSchedulePickupDrawer,
    datesAndTimeRangesForSchedulePickup,
    fetchingDatesAndTimeRangesForSchedulePickup,
    selectedPickupDate,
    setSelectedPickupDate,
    selectedTimeRange,
    setSelectedTimeRange,
    isSchedulePickupDisabled,
  }
}

export default useSchedulePickup
